/**
 |--------------------------------------------------------------------------
 | TIME SHEETS : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const time_sheets = [// {
    //  path: '/current/assignments', component: require('pages/timesheets/current_assignments.vue').default,
    //  name: 'current_assignments',
    //  meta: {
    //   requiresAuth: true,
    //   authLevelRequired: userLevelGroups.crm_man_ac_con,
    //   title: "Current Assignments",
    //   icon: "fas fa-handshake"
    //  }
    // },
    // {
    //  path: '/historic/assignments', component: require('pages/timesheets/historic_timesheets.vue').default,
    //  name: 'historic_timesheets',
    //  meta: {
    //   requiresAuth: true,
    //   authLevelRequired: userLevelGroups.crm_man_ac_con,
    //   title: "Historic Assignments",
    //   icon: "fas fa-handshake-alt-slash"
    //  }
    // },
    // {
    //  path: '/timesheets/excel', component: require('pages/timesheets/excel.vue').default,
    //  name: 'excel_timesheets',
    //  meta: {
    //   requiresAuth: true,
    //   authLevelRequired: userLevelGroups.crm_man_ac_con,
    //   title: "Excel Timesheets",
    //   icon: "fas fa-file-excel"
    //  }
    // },
    {
        path: '/timesheets/bible',
        component: require('pages/timesheets/bible.vue').default,
        name: 'bible',
        meta: {requiresAuth: true, title: "Bible", icon: "fas fa-book-open"}
    }, {
        path: '/timesheets/this_week',
        component: require('pages/timesheets/this_week.vue').default,
        name: 'timesheets_this_week',
        meta: {requiresAuth: true, title: "Timesheets This Week", icon: "fas fa-user-clock"}
    }, {
        // path: '/timesheets/submitted', component: require('pages/timesheets/submitted.vue').default,
        path: '/timesheets/submitted',
        component: require('pages/timesheets/campanies.vue').default,
        name: 'submitted_timesheets1',
        meta: {requiresAuth: true, title: "Submitted Timesheets", icon: "fas fa-user-clock"}
    }, {
        path: '/timesheets/submitted/details',
        component: require('pages/timesheets/submitted_details.vue').default,
        name: 'submitted_timesheets',
        meta: {requiresAuth: true, title: "Submitted Timesheets Details", icon: "fas fa-user-clock"}
    }, {
        path: '/timesheets/reopen_reset',
        component: require('pages/timesheets/reopen_reset.vue').default,
        name: 'reopen_reset',
        meta: {requiresAuth: true, title: "Reopen / Reset Timesheets", icon: "fas fa-sync-alt"}
    }, // {
    //  path: '/timesheets/history', component: require('pages/timesheets/history.vue').default,
    //  name: 'timesheets_history',
    //  meta: {
    //   requiresAuth: true,
    //   authLevelRequired: userLevelGroups.crm_man_ac_con,
    //   title: "Timesheets History",
    //   icon: "fas fa-book-open"
    //  }
    // },

    {
        path: '/a/r2/timesheets/company/:company_id/select_period',
        component: require('pages/sunset/timesheets/admin/timesheet_select_period.vue').default,
        name: 'a_timesheet_r2_select_period',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-admin',
            
        }
    }, {
        path: '/a/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date',
        component: require('pages/sunset/timesheets/admin/timesheet_select_sites.vue').default,
        name: 'a_timesheet_r2_select_sites',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-admin',
            
        }
    }, {
        path: '/a/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/order/:order_id/order_job/:order_job_id/workers',
        component: require('pages/sunset/timesheets/admin/timesheet_site_workers.vue').default,
        name: 'a_timesheet_r2_select_site_worker',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-admin',
            
        }
    }, {
        path: '/a/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/order/:order_id/order_job/:order_job_id/assign_workers',
        component: require('pages/sunset/timesheets/admin/assign_worker.vue').default,
        name: 'a_timesheet_r2_assign_worker',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-admin',
            
        }
    },

    {
        path: '/a/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/order/:order_id/order_job/:order_job_id/workers/:timesheet_id',
        component: require('pages/sunset/timesheets/admin/timesheet_edit_timesheet.vue').default,
        name: 'a_timesheet_edit_worker',
        props: true,
        meta: {
            requiresAuth: true,
            title: "Submit Timesheets",
            icon: "fas fa-user-clock",
            key: 'submit-timesheets-admin',
            
        }
    },
    {
        path: '/r2/admin/timesheets/company/:company_id/:start_date/:end_date/activity',
        name: 'a_timesheet_activity_search',
        component: () => import('pages/sunset/timesheets/admin/timesheet_logs.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            title: 'Timesheet Activity Logs', key: 'timesheet-logs',
        },
    },
    {
        path: '/a/new/timesheets/company/:company_id/preview/:start_date/:end_date',
        component: require('pages/sunset/timesheets/admin/timesheet_preview_all.vue').default,
        name: 'a_timesheet_r2_submit_preview',
        props: true,
        meta: {requiresAuth: true, title: "Preview Timesheets", icon: "fas fa-user-clock"}
    }, {
        path: '/a/r2/timesheets/company/:company_id/select_sites/:start_date/:end_date/import_timesheets',
        component: require('pages/sunset/timesheets/admin/timesheet_import.vue').default,
        name: 'a_timesheet_r2_import_timesheets',
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    }, {
        path: '/r2/admin/timesheets/company/:company_id/imports/:importId/processing/:start_date/:end_date',
        name: 'a_timesheet_import_processing',
        component: () => import('pages/sunset/timesheets/import_processing.vue'),
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    }, {
        path: '/r2/admin/timesheets/company/:company_id/imports/:importId/preview/:start_date/:end_date',
        name: 'a_timesheet_import_preview',
        component: () => import('pages/sunset/timesheets/import_preview.vue'),
        props: true,
        meta: {title: 'Timesheet Import', key: 'timesheet-import-admin', }
    },



];
export default time_sheets;
